<template>
    <div>
        <CDataTable
        :items="this.$store.state.transfers.bidsPlaced"
        :fields="[{key:'playername', label:'Name'}, {key:'position', label:'Pos'}, {key:'teamname', label:'Team'}, {key:'amount', label:'Amount'}, {key:'status', label:'Status'}]"
        hover
        striped
        bordered
        small
        fixed
    >
        </CDataTable>
    </div>
</template>

<script>

export default {
  name: 'MyBids',
  data () {
    return {
      bidModal: false,
      selectedPlayer: {},
      bidValue: 0.5,
      invalidBidMessage: "123"
    }
  },
  created() {
    this.$store.dispatch("loadClubBids", {clubId:this.$auth.user['https://tlog-online.co.uk/club_id']});
  },
  computed: {
      myBidList: function() {
          return this.$store.state.transfers.bidsPlaced;
      }
  },
  methods: {
    showBidModal: function(player_id) {
      var auctionList = this.$store.state.auctionList;
      for(var i = 0; i < auctionList.length; i++) {
        if(auctionList[i].player_id == player_id) {
          this.selectedPlayer = auctionList[i];
          break;
        }
      }

      this.bidModal = true;
    },
    placeBid: function() {
      var isValid = this.validateBidValue(this.bidValue);

      if(isValid && this.$auth.isAuthenticated) {
        this.$store.dispatch("savePlaceBid", {playerId:this.selectedPlayer.player_id,
                                              clubId:this.$auth.user['https://tlog-online.co.uk/club_id'],
                                              amount: this.bidValue});
        this.bidModal = false;
      }
    },
    validateBidValue: function(value) {
      var num = Number(value);

      return num >= 0.5 && num % 0.25 == 0;
    }
  }
}
</script>